import React from "react"
import avatar from "avatar/poppy.svg"

const Poppy = (props) => <img src={avatar} className="avatar" {...props} />

export default Poppy
